import { useState } from 'react'

const useTourCC = () => {
    const [openTour, setOpenTour] = useState(false)

    return {
        openTour,
        setOpenTour
    }
}

export default useTourCC